import React, { Component } from 'react';
import { connect } from 'react-redux';

import Dim from 'web/components/common/modal/common/Dim';
import Consulting from 'web/components/common/modal/Consulting';

import { consultingOption } from 'shared/data/sellingData';

import { initModal, pushModal } from 'shared/actions/modal.action';

@connect(
  (state, props) => ({
    type: state.shared.modal.type,
    data: state.shared.modal.data,
  }),
  { initModal, pushModal },
)
class ConsultingContainer extends Component {
  state = {
    options: {
      gender: 'woman',
      age: '10',
    },
  };

  handleChange = e => {
    const { target = {} } = e;
    const { name, value } = target;

    this.setState({
      options: {
        ...this.state.options,
        [name]: value,
      },
    });

    // console.log({ target, name, value, checked });
  };

  handleSubmit = e => {
    e.preventDefault();
    //TODO consulting request
  };

  render() {
    const { options = {} } = this.state;
    const { initModal } = this.props;
    // console.log({ data, options });

    const title = `상담신청이 접수 되었습니다.`;
    const desc = `아래 설문의 답을 선택해 주시면 \n우선적으로 상담해 드립니다.`;

    return (
      <Dim onClick={initModal}>
        <div style={{ position: 'relative', width: '325px' }}>
          <Consulting
            title={title}
            desc={desc}
            formData={consultingOption}
            handleChange={this.handleChange}
            handleSubmit={this.handleSubmit}
            options={options}
            initModal={initModal}
          />
        </div>
      </Dim>
    );
  }
}

export default ConsultingContainer;
